import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "docReview-container"
  }, [_c('a-card', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _c('a-space', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a-button', {
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v("返回")]), _vm.mode != 'view' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.auditDoc
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1)]), _c('a-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_vm.form.tempId == 1 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("绵阳中学英才学校纪委办拟文稿")]), _c('a-row', {
    staticStyle: {
      "margin-top": "0.625rem"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-left"
  }, [_c('div', [_vm._v(" 文件编号： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.fileCode) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 缓急： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.urgency) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 密级： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.secretLevel) + " ")])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left double-height"
  }, [_c('div', [_vm._v("文件名称：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileName))])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right double-height"
  }, [_c('div', [_vm._v("附件：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, _vm._l(_vm.form.fileList, function (item) {
    return _c('div', {
      key: item.uid
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm.form.fileList && _vm.form.fileList.length != 0 ? _c('a-button', {
      attrs: {
        "type": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDownPreview(item);
        }
      }
    }, [_vm._v(" 下载 ")]) : _vm._e()], 1);
  }), 0)])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left triple-height-x2"
  }, [_c('div', [_vm._v("签发：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.signauditopinion) + " "), _c('div', {
    staticClass: "sign-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("纪委书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "5.625rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.signsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.signsignimg !== '' && _vm.form.docData.signsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.signsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right triple-second-height-x2"
  }, [_c('div', [_vm._v("初核：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.firstauditopinion) + " "), _c('div', {
    staticClass: "sign-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("纪委办主任（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "3.625rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.firstsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.firstsignimg !== '' && _vm.form.docData.firstsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.firstsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("拟稿：")]), _c('span', [_vm._v("拟稿人（签字）:")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.createTime) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.signImgUrl !== '' && _vm.form.signImgUrl != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.signImgUrl,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("主送")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.zsNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("抄送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1)], 1) : _vm._e(), _vm.form.tempId == 2 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("中共绵阳中学英才学校委员会拟文稿")]), _c('a-row', {
    staticStyle: {
      "margin-top": "0.625rem"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-left"
  }, [_c('div', [_vm._v(" 文件编号： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileCode))])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 缓急： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.urgency) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 密级： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.secretLevel) + " ")])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left double-height"
  }, [_c('div', [_vm._v("文件名称：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileName))])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right double-height"
  }, [_c('div', [_vm._v("附件：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, _vm._l(_vm.form.fileList, function (item) {
    return _c('div', {
      key: item.uid
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm.form.fileList && _vm.form.fileList.length != 0 ? _c('a-button', {
      attrs: {
        "type": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDownPreview(item);
        }
      }
    }, [_vm._v(" 下载 ")]) : _vm._e()], 1);
  }), 0)])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left triple-height-x2"
  }, [_c('div', [_vm._v("签发：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.signauditopinion) + " "), _c('div', {
    staticClass: "sign-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("党委书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "5.625rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.signsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.signsignimg !== '' && _vm.form.docData.signsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.signsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right triple-first-height"
  }, [_c('div', [_vm._v("复核：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.secondauditopinion) + " "), _c('div', {
    staticClass: "sign-content-fuhe"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("专职副书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "1.625rem"
    }
  }, [_vm._v(" 日期：日期：" + _vm._s(_vm.form.docData.secondsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.secondsignimg !== '' && _vm.form.docData.secondsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.secondsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("初核：")]), _c('span', [_vm._v(" " + _vm._s(_vm.form.docData.firstauditopinion) + " ")])]), _c('span', [_vm._v("党委办负责人（主任）（签字）:")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.firstsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.firstsignimg !== '' && _vm.form.docData.firstsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.firstsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("拟稿：")]), _c('span', [_vm._v("拟稿人（签字）:")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.createTime) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.signImgUrl !== '' && _vm.form.signImgUrl != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.signImgUrl,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v(" 会签： "), _vm.form.meetingResult && _vm.form.meetingResult === 0 ? _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" 不通过 ")]) : _vm._e(), _vm.form.meetingResult && _vm.form.meetingResult === 1 ? _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" 通过 ")]) : _vm._e()]), _vm.form.docData.meetingImg.length > 0 ? _c('div', {
    staticClass: "content-font"
  }, _vm._l(_vm.form.docData.meetingImg, function (item, index) {
    return _c('span', {
      key: index
    }, [_c('img', {
      attrs: {
        "height": "60",
        "src": "".concat(_vm.config.baseUrl).concat(item)
      }
    })]);
  }), 0) : _vm._e()])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("主送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.zsNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("抄送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-left"
  }, [_c('div', [_vm._v("打印：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.form.docData.printsignimg !== '' && _vm.form.docData.printsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.printsignimg,
      "alt": ""
    }
  }) : _vm._e()])]), _c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  }, [_c('div', [_vm._v("校对：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.form.docData.proofreadsignimg !== '' && _vm.form.docData.proofreadsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.proofreadsignimg,
      "alt": ""
    }
  }) : _vm._e()])]), _c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  }, [_c('div', [_vm._v("份数：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  })])], 1)], 1) : _vm._e(), _vm.form.tempId == 3 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("绵阳中学英才学校发文审批单")]), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form2-content-top-left"
  }, [_vm._v(" 理事长签发： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.chairmanauditopinion) + " "), _vm.form.docData.chairmansignimg !== '' && _vm.form.docData.chairmansignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.chairmansignimg,
      "alt": ""
    }
  }) : _vm._e()])])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "form2-content-top-right-top"
  }, [_vm._v("拟稿部门")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("审稿部门")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("分管校级领导审核")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("会签")])]), _c('a-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "form2-content-top-right-top"
  }, [_c('span', {
    staticClass: "content-font"
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.form.docData.draftauditopinion) + " ")]), _c('a-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm.form.docData.draftsignimg !== '' && _vm.form.docData.draftsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.draftsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.form.docData.reviewerauditopinion) + " ")]), _c('a-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm.form.docData.reviewersignimg !== '' && _vm.form.docData.reviewersignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.reviewersignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.form.docData.leadauditopinion) + " ")]), _c('a-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm.form.docData.leadsignimg !== '' && _vm.form.docData.leadsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.leadsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left"
  }, [_c('div', [_vm._v("日期")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.formDate))])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left double-height"
  }, [_c('div', [_vm._v("标题")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right double-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.fileName) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height"
  }, [_c('div', [_vm._v("抄送")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height"
  }, [_c('div', {
    staticClass: "content-font triple-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height"
  }, [_c('div', [_vm._v("附件")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height-content"
  }, [_c('div', {
    staticClass: "content-font"
  }, _vm._l(_vm.form.fileList, function (item) {
    return _c('div', {
      key: item.uid
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm.form.fileList && _vm.form.fileList.length != 0 ? _c('a-button', {
      attrs: {
        "type": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDownPreview(item);
        }
      }
    }, [_vm._v(" 下载 ")]) : _vm._e()], 1);
  }), 0)])])], 1)], 1) : _vm._e(), _vm.form.tempId == 4 ? _c('div', [_c('div', {
    staticClass: "form-title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(" 绵阳中学英才学校公文处理笔笺 ")]), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.form.fileCode || ''))]), _c('a-row', [_c('a-col', {
    staticStyle: {
      "border-top": "1px solid red"
    },
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("公文标题")])])]), _c('a-col', {
    staticStyle: {
      "border-top": "1px solid red"
    },
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.docData.filename))])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("拟办意见")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.proposedauditopinion || '') + " "), _c('div', {
    staticStyle: {
      "margin-top": "3.625rem",
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "padding-right": "10px"
    }
  }, [_vm.form.docData.proposedsignimg !== '' && _vm.form.docData.proposedsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.proposedsignimg,
      "alt": ""
    }
  }) : _vm._e()]), _c('span', [_vm._v(" " + _vm._s(_vm.form.proposedsigndate) + " ")])])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("党委书记批示")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.memorandumauditopinion || '') + " "), _c('div', {
    staticStyle: {
      "margin-top": "3.625rem",
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "padding-right": "10px"
    }
  }, [_vm.form.docData.memorandumsignimg !== '' && _vm.form.docData.memorandumsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.memorandumsignimg,
      "alt": ""
    }
  }) : _vm._e()]), _c('span', [_vm._v(" " + _vm._s(_vm.form.memorandumsigndate) + " ")])])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("办理结果")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.result))])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("附件")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height-content",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, _vm._l(_vm.form.fileList, function (item) {
    return _c('div', {
      key: item.uid
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm.form.fileList && _vm.form.fileList.length != 0 ? _c('a-button', {
      attrs: {
        "type": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDownPreview(item);
        }
      }
    }, [_vm._v(" 下载 ")]) : _vm._e()], 1);
  }), 0)])])], 1), _c('span', {
    staticStyle: {
      "display": "block",
      "padding": "10px",
      "font-size": "1.825rem",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v(" 发布范围 ")]), _c('div', {
    staticClass: "user-container"
  }, _vm._l(this.form.copyDelivery.userData, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "user-box"
    }, [_c('div', {
      staticClass: "user-box-row"
    }, [_c('a-icon', {
      attrs: {
        "type": "tag"
      }
    }), _c('div', {
      staticClass: "wto",
      attrs: {
        "title": "".concat(item.name)
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1)]);
  }), 0)], 1) : _vm._e(), _c('a-modal', {
    attrs: {
      "visible": _vm.previewShow,
      "footer": null,
      "centered": true,
      "width": "80rem"
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.previewSrc,
      "seamless": ""
    }
  })])], 1)], 1), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_c('div', {
    staticClass: "right-timeline-content"
  }, [_c('a-timeline', _vm._l(_vm.flowList, function (item, index) {
    return _c('a-timeline-item', {
      key: index,
      attrs: {
        "color": item.auditStatus === 1 ? 'rgb(79, 191, 73)' : item.auditStatus === 0 ? 'rgb(220, 33, 39)' : 'rgb(24, 144, 255)'
      }
    }, [_c('div', {
      staticClass: "timeline-title",
      attrs: {
        "title": item.auditStepName
      }
    }, [_vm._v(" " + _vm._s(item.auditStepName || '') + " ")]), _c('a-card', {
      staticClass: "processMsg",
      attrs: {
        "body-style": {
          padding: '10px'
        }
      }
    }, [item.auditStep === 3 && _vm.form.tempId === 2 ? _c('a-row', [item.counterSignChildren !== null ? _c('a-table', {
      attrs: {
        "size": "small",
        "dataSource": item.counterSignChildren,
        "columns": _vm.columns,
        "pagination": false,
        "rowKey": "number",
        "showHeader": false
      },
      scopedSlots: _vm._u([{
        key: "auditStatus",
        fn: function fn(text, record) {
          return [record.auditStatus === 0 ? _c('a-tag', {
            staticClass: "tag-border-red"
          }, [_vm._v(" 不通过 ")]) : _vm._e(), record.auditStatus === 1 ? _c('a-tag', {
            staticClass: "tag-border-green"
          }, [_vm._v(" 通过 ")]) : _vm._e(), record.auditStatus === 2 ? _c('a-tag', {
            staticClass: "tag-border-orange"
          }, [_vm._v(" 弃票 ")]) : _vm._e(), record.auditStatus === -1 ? _c('a-tag', {
            staticClass: "tag-border-black"
          }, [_vm._v(" 未投票 ")]) : _vm._e()];
        }
      }], null, true)
    }) : _vm._e(), _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('a-tooltip', {
      attrs: {
        "placement": "topLeft",
        "arrow-point-at-center": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" 会签过期时间前都可进行投票，超过该时间后则无法进行投票。 ")]), _c('a-icon', {
      staticStyle: {
        "color": "#1890ff"
      },
      attrs: {
        "type": "question-circle",
        "theme": "filled"
      }
    })], 1), _vm._v(" 会签过期时间：" + _vm._s(item.expireTime) + " ")], 1), item.auditStep !== 0 ? _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v(" " + _vm._s('会签范围：') + " "), _c('a-tooltip', {
      attrs: {
        "title": item.organName + '/' + item.postName
      }
    }, [item.organName ? _c('a-tag', {
      staticStyle: {
        "text-overflow": "ellipsis",
        "max-width": "200px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "vertical-align": "bottom"
      },
      attrs: {
        "color": "#bfbfbf"
      }
    }, [_vm._v(" " + _vm._s(item.postName) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('a-tooltip', {
      attrs: {
        "placement": "topLeft",
        "arrow-point-at-center": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('p', [_vm._v(" 1、实际通过比例 = 通过人数 / 总人数 x 100% 。 ")]), _c('p', [_vm._v(" 2、实际通过比例 ≥ 预设通过比例 ，会签结果为通过。 ")]), _c('p', [_vm._v(" 3、实际通过比例 ≤ 预设通过比例 ，会签结果为不通过。 ")])]), _c('a-icon', {
      staticStyle: {
        "color": "#1890ff"
      },
      attrs: {
        "type": "question-circle",
        "theme": "filled"
      }
    })], 1), _vm._v(" 实际通过比例：" + _vm._s(item.actualPassPercentage) + "% ")], 1), _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('a-tooltip', {
      attrs: {
        "placement": "topLeft",
        "arrow-point-at-center": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" 参与会签所有人都完成投票后，或当前时间超过过期时间，将自动计算会签投票结果。 ")]), _c('a-icon', {
      staticStyle: {
        "color": "#1890ff"
      },
      attrs: {
        "type": "question-circle",
        "theme": "filled"
      }
    })], 1), _vm._v(" 会签投票结果： "), item.auditStatus !== 1 && item.auditStatus !== 0 ? _c('a-tag', {
      staticClass: "tag-border-blue"
    }, [_vm._v(" 待审批 ")]) : _vm._e(), item.auditStatus === 1 ? _c('a-tag', {
      staticClass: "tag-border-green"
    }, [_vm._v(" 通过 ")]) : _vm._e(), item.auditStatus === 0 ? _c('a-tag', {
      staticClass: "tag-border-red"
    }, [_vm._v(" 不通过 ")]) : _vm._e()], 1), _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('a-tooltip', {
      attrs: {
        "placement": "topLeft",
        "arrow-point-at-center": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('p', [_vm._v(" 1、实际通过比例 = 通过人数 / 总人数 x 100% 。 ")]), _c('p', [_vm._v(" 2、实际通过比例 ≥ 预设通过比例 ，会签结果为通过。 ")]), _c('p', [_vm._v(" 3、实际通过比例 ≤ 预设通过比例 ，会签结果为不通过。 ")])]), _c('a-icon', {
      staticStyle: {
        "color": "#1890ff"
      },
      attrs: {
        "type": "question-circle",
        "theme": "filled"
      }
    })], 1), _vm._v(" 预设通过比例： " + _vm._s(item.passPercentage) + "% ")], 1)], 1) : _c('a-row', [item.auditStep === 0 ? _c('div', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v(" " + _vm._s(item.auditStepName + '人：' + "".concat(item.userName === null ? '' : item.userName)) + " "), _c('a-tooltip', {
      attrs: {
        "title": item.organName + '/' + item.postName
      }
    }, [item.organName ? _c('a-tag', {
      staticStyle: {
        "text-overflow": "ellipsis",
        "max-width": "200px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "vertical-align": "bottom"
      },
      attrs: {
        "color": "#bfbfbf"
      }
    }, [_vm._v(" " + _vm._s(item.organName) + "/" + _vm._s(item.postName) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), item.auditStep !== 0 ? _c('div', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('span', [_vm._v(" " + _vm._s('审核人：' + "".concat(item.userName === null ? '' : item.userName)) + " ")]), _c('a-tooltip', {
      attrs: {
        "title": item.organName + '/' + item.postName
      }
    }, [item.organName ? _c('a-tag', {
      staticStyle: {
        "text-overflow": "ellipsis",
        "max-width": "200px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "vertical-align": "bottom"
      },
      attrs: {
        "color": "#bfbfbf"
      }
    }, [_vm._v(" " + _vm._s(item.organName) + "/" + _vm._s(item.postName) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), item.auditStep === 0 ? _c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v(" " + _vm._s('拟稿时间：' + "".concat(item.processTime === null ? '' : item.processTime, " ")) + " ")]) : _vm._e(), item.auditStep !== 0 ? _c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v(" " + _vm._s('审核时间：' + "".concat(item.processTime === null ? '' : item.processTime, " ")) + " ")]) : _vm._e(), item.auditStep !== 0 ? _c('a-col', [_vm._v(" 审核状态： "), item.auditStatus !== 1 && item.auditStatus !== 0 ? _c('span', {
      staticClass: "a-tag ant-tag ant-tag-red",
      staticStyle: {
        "text-align": "justify",
        "text-align-last": "justify",
        "width": "52px",
        "color": "rgb(24, 144, 255)",
        "background": "rgba(24, 144, 255, 0.1)",
        "border-color": "rgba(24, 144, 255, 0.8)"
      }
    }, [_vm._v(" 待审批 ")]) : _vm._e(), item.auditStatus === 1 ? _c('span', {
      staticClass: "a-tag ant-tag ant-tag-red",
      staticStyle: {
        "text-align": "justify",
        "text-align-last": "justify",
        "width": "52px",
        "color": "rgb(79, 191, 73)",
        "background": "rgba(79, 191, 73, 0.1)",
        "border-color": "rgba(79, 191, 73, 0.8)"
      }
    }, [_vm._v(" 通过 ")]) : _vm._e(), item.auditStatus === 0 ? _c('span', {
      staticClass: "a-tag ant-tag ant-tag-red",
      staticStyle: {
        "text-align": "justify",
        "text-align-last": "justify",
        "width": "52px",
        "color": "rgb(220, 33, 39)",
        "background": "rgba(220, 33, 39, 0.1)",
        "border-color": "rgba(220, 33, 39, 0.8)"
      }
    }, [_vm._v(" 不通过 ")]) : _vm._e()]) : _vm._e(), item.auditStep !== 0 ? _c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v(" " + _vm._s('审核意见：' + "".concat(item.auditOpinion === null ? '' : item.auditOpinion, " ")) + " ")]) : _vm._e()], 1)], 1)], 1);
  }), 1)], 1), _c('a-divider'), _vm.form.tempId == 1 && _vm.mode == 'firstTrial' ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rulesAudit
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "初核意见",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditOpinion"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "auto-size": {
        minRows: 5
      },
      "maxLength": 200
    },
    model: {
      value: _vm.form.auditOpinion,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditOpinion", $$v);
      },
      expression: "form.auditOpinion"
    }
  })], 1)], 1) : _vm._e(), _vm.form.tempId == 1 && _vm.mode == 'signIssue' ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rulesAudit
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "签发意见",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditOpinion"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "auto-size": {
        minRows: 5
      },
      "maxLength": 200
    },
    model: {
      value: _vm.form.auditOpinion,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditOpinion", $$v);
      },
      expression: "form.auditOpinion"
    }
  })], 1)], 1) : _vm._e(), _vm.form.tempId == 2 && _vm.mode == 'firstTrial' ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rulesAudit
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "初核意见",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditOpinion"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "auto-size": {
        minRows: 5
      },
      "maxLength": 200
    },
    model: {
      value: _vm.form.auditOpinion,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditOpinion", $$v);
      },
      expression: "form.auditOpinion"
    }
  })], 1)], 1) : _vm._e(), _vm.form.tempId == 2 && _vm.mode == 'reCheck' ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rulesAuditRecheck
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "复核意见",
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditOpinion"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "auto-size": {
        minRows: 3
      },
      "maxLength": 200
    },
    model: {
      value: _vm.form.auditOpinion,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditOpinion", $$v);
      },
      expression: "form.auditOpinion"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "是否需要会签",
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "isCounterSign"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.isCounterSign,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isCounterSign", $$v);
      },
      expression: "form.isCounterSign"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1), _vm.form.isCounterSign === 1 ? _c('a-form-model-item', {
    attrs: {
      "label": "会签过期时间",
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "expireTime"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-time": "",
      "valueFormat": "YYYY-MM-DD HH:mm:ss"
    },
    model: {
      value: _vm.form.expireTime,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "expireTime", $$v);
      },
      expression: "form.expireTime"
    }
  })], 1) : _vm._e(), _vm.form.isCounterSign === 1 ? _c('a-form-model-item', {
    attrs: {
      "label": "预设通过比例",
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 14
      },
      "prop": "passPercentage"
    }
  }, [_c('a-input-number', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "min": 0,
      "max": 100,
      "formatter": function formatter(value) {
        return "".concat(value, "%");
      },
      "parser": function parser(value) {
        return value.replace('%', '');
      }
    },
    model: {
      value: _vm.form.passPercentage,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "passPercentage", $$v);
      },
      expression: "form.passPercentage"
    }
  }), _c('a-tooltip', {
    attrs: {
      "placement": "topLeft",
      "arrow-point-at-center": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', [_vm._v("1、实际通过比例 = 通过人数 / 总人数 x 100% 。")]), _c('p', [_vm._v("2、实际通过比例 ≥ 预设通过比例 ，会签结果为通过。")]), _c('p', [_vm._v("3、实际通过比例 ≤ 预设通过比例 ，会签结果为不通过。")])]), _c('a-icon', {
    staticStyle: {
      "color": "#1890ff",
      "marginleft": "5px"
    },
    attrs: {
      "type": "question-circle",
      "theme": "filled"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.form.tempId == 2 && _vm.mode == 'groupSign' ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rulesAudit
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")]), _c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("弃票")])], 1)], 1)], 1) : _vm._e(), _vm.form.tempId == 2 && _vm.mode == 'signIssue' ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rulesAudit
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "签发意见",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditOpinion"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "auto-size": {
        minRows: 5
      },
      "maxLength": 200
    },
    model: {
      value: _vm.form.auditOpinion,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditOpinion", $$v);
      },
      expression: "form.auditOpinion"
    }
  })], 1)], 1) : _vm._e(), _vm.form.tempId == 3 || _vm.form.tempId == 4 ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rulesAudit
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "审核意见",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditOpinion"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "",
      "auto-size": {
        minRows: 5
      },
      "maxLength": _vm.form.auditStep === 4 ? 200 : 200
    },
    model: {
      value: _vm.form.auditOpinion,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditOpinion", $$v);
      },
      expression: "form.auditOpinion"
    }
  })], 1)], 1) : _vm._e(), _vm.form.tempId == 2 && _vm.mode == 'proofread' ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rulesAudit
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.form.tempId == 2 && _vm.mode == 'print' ? _c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [false ? _c('a-form-model-item', {
    attrs: {
      "label": "是否通过",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "auditStatus"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.form.auditStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "auditStatus", $$v);
      },
      expression: "form.auditStatus"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("通过")])], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "label": "打印份数",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "shareency"
    }
  }, [_c('a-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1
    },
    model: {
      value: _vm.form.shareency,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "shareency", $$v);
      },
      expression: "form.shareency"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };